import { useCallback } from 'react'
import { Button, Modal, Text } from '../../../components/BaseComponents'
import { ONBOARDING_V2_ROUTE_NAMES, OnboardingTaskIdents } from '../config'
import { UploadPrevMonthStatementStatus } from '../../Dashboard/UserActionItems/userActionItemStatuses'
import { markUserActionItemCompleteIfExists } from '../../Dashboard/UserActionItems/service'
import { useAnalyticsTrack } from '../../Amplitude'
import { useNavigate } from 'react-router-dom'

export const SkipUploadStatementsModal = ({
  closeModal,
}: {
  closeModal: () => void
}) => {
  const track = useAnalyticsTrack()
  const navigate = useNavigate()

  const handleSkipClick = useCallback(async () => {
    track('completed onboarding item upload statements', { status: 'skipped' })
    await markUserActionItemCompleteIfExists(
      OnboardingTaskIdents.UPLOAD_PREV_MONTH_STATEMENTS,
      track,
      UploadPrevMonthStatementStatus.skipped
    )
    navigate(ONBOARDING_V2_ROUTE_NAMES.ONBOARDING_COMPLETE)
  }, [track, navigate])

  const handleCancelClick = () => {
    track('cancelled skip upload statements')
    closeModal()
  }

  return (
    <Modal closeIcon onClose={handleCancelClick} open size="small">
      <Modal.Header>Are you sure you want to skip?</Modal.Header>
      <Modal.Content>
        <Text style={{ padding: '16px' }}>
          Without your bank statements, we won’t be able to get the full picture
          of your business finances. This is important for bookkeeping
          completeness and compliance.
        </Text>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancelClick} variant="actionLink">
          Go Back
        </Button>
        <Button onClick={handleSkipClick} variant="secondaryWhite">
          Skip
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
